import clsx from 'clsx';
import React from 'react';

import Button from '@/src/components/common/Elements/Button/Button';
import LongTextByWidth from '@/src/components/common/Elements/LongText/LongTextByWidth';
import FileCard from '@/src/components/project/Inbox2/Elements/FileCard/FileCard';

import { EmailThreadEntryFiles, InboxEntryFile } from '../../../../../types';
import AttachmentItem from '../../Attachments/AttachmentItem/AttachmentItem';

type AttachmentsProps = {
  files: EmailThreadEntryFiles;
  onClickMore: (event: React.MouseEvent) => void;
  onClick: (file: InboxEntryFile) => void;
};

export const FILES_DISPLAYED_COUNT = 3;

const Attachments = ({ files, onClick, onClickMore }: AttachmentsProps) => {
  const remainingFilesCount = files.list.length - FILES_DISPLAYED_COUNT;

  return (
    <div
      className={clsx('attachment-files', 'tw-flex tw-items-center tw-flex-wrap', 'tw-pt-[5px]')}
    >
      {files.list.slice(0, FILES_DISPLAYED_COUNT).map((file) => (
        <AttachmentItem
          key={file.id}
          file={file}
          containerClassName="tw-max-w-[100px] tw-w-full"
          onClick={onClick}
        >
          {/* <LongText tooltipId={`fn_${file.id}`} value={file.name} maxLength={10} /> */}

          <LongTextByWidth
            className={clsx('tw-text-cfo-black ', 'group-hover:tw-text-cfo-blue-600')}
            id={`fn_${file.id}`}
            value={file.name}
            maxWidth={70}
            maxLines={1}
            highlightBySearchTerm={true}
          />
        </AttachmentItem>
      ))}

      {files.list.length > 3 && (
        <FileCard className={clsx('tw-p-[4px] tw-px-[5px]')}>
          <Button
            className={clsx(
              'tw-mr-0 tw-p-0',
              'group-hover:tw-text-cfo-blue-600 group-hover:tw-font-brandonTextMedium'
            )}
            buttonClassSettings={{
              variant: 'style_unset',
              size: 'xs',
            }}
            data-tooltip-id={`fileCounter_tooltip`}
            data-testid="attachments-mores_files-button"
            onClick={onClickMore}
            stopPropagation={true}
          >
            +{remainingFilesCount}
          </Button>
        </FileCard>
      )}
    </div>
  );
};

export default Attachments;
